import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FiHome, FiTruck, FiPhone, FiBookOpen } from 'react-icons/fi';
import './NotFoundPage.css';

const NotFoundPage = () => (
  <>
    <Helmet>
      <title>Page introuvable (404) | VIP Limousine Paris</title>
      <meta name="robots" content="noindex, follow" />
      <meta name="description" content="Cette page n'existe pas ou a été déplacée. Retrouvez nos services de location de limousine avec chauffeur à Paris et en Île-de-France." />
    </Helmet>

    <section className="not-found">
      <div className="container">
        <span className="not-found-code">404</span>
        <h1>Cette page a pris une autre route</h1>
        <p>
          La page que vous cherchez n'existe pas ou a été déplacée. Nos limousines,
          elles, sont toujours disponibles 24h/24 à Paris et en Île-de-France.
        </p>

        <div className="not-found-links">
          <Link to="/" className="btn btn-primary"><FiHome /> Retour à l'accueil</Link>
          <Link to="/vehicules" className="btn btn-outline"><FiTruck /> Nos véhicules</Link>
          <Link to="/blog" className="btn btn-outline"><FiBookOpen /> Le blog</Link>
          <Link to="/contact" className="btn btn-outline"><FiPhone /> Nous contacter</Link>
        </div>

        <p className="not-found-phone">
          Besoin d'un devis immédiat ? <a href="tel:+33661630113">06 61 63 01 13</a>
        </p>
      </div>
    </section>
  </>
);

export default NotFoundPage;
